export enum VerseSegmentType {
  Flex = "flex",
  Mediant = "mediant",
  Termination = "termination",
}
